import { tv } from 'tailwind-variants';

export const iconStyle = tv({
  variants: {
    state: {
      inactive: 'rotate-180',
      active: 'rotate-0',
    },
  },
});

export const wrapper = tv({
  base: 'border-b border-borderColor last:border-none',
  variants: {
    space: {
      overflowing: 'pb-0',
      normal: 'pb-0',
    },
    type: {
      dropdown: 'relative pb-0 border-none',
      normal: 'py-4 first:py-0 first:pb-4',
    },
  },
});
export const carrotContainer = tv({
  base: 'text-center text-black',
});
export const textStyles = tv({
  base: 'text-sm font-sans font-bold',
  variants: {
    type: {
      dropdown: 'uppercase',
      normal: '',
    },
  },
});
export const headerContainer = tv({
  base: 'flex items-center select-none cursor-pointer max-md:px-4',
  variants: {
    type: {
      dropdown: 'justify-end gap-2',
      normal: 'justify-between',
    },
  },
});

export const headerTitleContainer = tv({
  base: 'flex gap-1 items-center',
  variants: {
    state: {
      active: 'pb-2',
      inactive: '',
    },
  },
});
